var transformAndValidate = function transformAndValidate(transformer, validator) {
  return function (value, allValues) {
    return validator(transformer(value), allValues);
  };
};
export default transformAndValidate;
export { transformAndValidate };